export default function RowContent(props) {
    return (
        <div className={"row px-2 my-2 mx-1 " + props.className}>
            {props.children}
        </div>
    )
}